import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import { fetchClients } from '../api/clientApi';
import SkeletonLoader from './SkeletonLoader';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const ClientLogosSection = () => {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const getClients = async () => {
      try {
        const response = await fetchClients();
        if (response.success) {
          setClients(response.data);
        } else {
          setError(response.message || 'Failed to fetch clients.');
        }
      } catch (err) {
        setError('Error fetching clients: ' + err.message);
      } finally {
        setLoading(false);
      }
    };

    getClients();
  }, []);

  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 2000,
    cssEase: 'linear',
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  if (loading) {
    return (
      <section className="py-12 bg-gray-900">
        <div className="container mx-auto px-4">
          <h2 className="text-4xl text-text-white font-bold relative after:content-[''] after:absolute after:bottom-0 after:left-1/2 after:-translate-x-1/2 after:w-20 after:h-1 after:bg-accent-red after:rounded-sm after:bottom-[-15px] text-center mb-8">My Valued Clients</h2>
          <SkeletonLoader type="clientLogos" />
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section className="py-12 bg-gray-900">
        <div className="container mx-auto px-4">
          <p className="text-center text-red-500">{error}</p>
        </div>
      </section>
    );
  }

  if (clients.length === 0) {
    return null;
  }

  return (
    <section className="py-12 bg-gray-900">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl text-text-white font-bold relative after:content-[''] after:absolute after:bottom-0 after:left-1/2 after:-translate-x-1/2 after:w-20 after:h-1 after:bg-accent-red after:rounded-sm after:bottom-[-15px] text-center mb-8">Trusted By</h2>
        <Slider {...settings}>
          {clients.map((client) => (
            <div key={client.id} className="flex justify-center items-center p-4">
              <img
                src={client.logo}
                alt={client.name}
                className="max-h-20 w-auto object-contain mx-auto"
                loading="lazy"
              />
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default ClientLogosSection;